import { SOUNDS_TYPE } from 'app/constants/sounds.constants'

export const getSoundsCategory = (pathname: string): SOUNDS_TYPE => {
  if (pathname.includes('sonidos')) {
    return SOUNDS_TYPE.SONIDOS
  }
  return SOUNDS_TYPE.SOUNDS
}
